export default __webpack_public_path__ + "3aceaca2c55e5f4d4896c2c9f788cffa.png";